function CustomMarker(latlng, map, args) {
    this.latlng = latlng;
    this.args = args;
    this.setMap(map);
}



function initMap() {
    var myLatLng = {lat: 50.7250273, lng: 1.6128448};
    // https://snazzymaps.com/style/54/routexl
//    var styles = [{"featureType":"administrative","elementType":"all","stylers":[{"visibility":"on"},{"saturation":-100},{"lightness":20}]},{"featureType":"road","elementType":"all","stylers":[{"visibility":"on"},{"saturation":-100},{"lightness":40}]},{"featureType":"water","elementType":"all","stylers":[{"visibility":"on"},{"saturation":-10},{"lightness":30}]},{"featureType":"landscape.man_made","elementType":"all","stylers":[{"visibility":"simplified"},{"saturation":-60},{"lightness":10}]},{"featureType":"landscape.natural","elementType":"all","stylers":[{"visibility":"simplified"},{"saturation":-60},{"lightness":60}]},{"featureType":"poi","elementType":"all","stylers":[{"visibility":"off"},{"saturation":-100},{"lightness":60}]},{"featureType":"transit","elementType":"all","stylers":[{"visibility":"off"},{"saturation":-100},{"lightness":60}]}]

    var mapadherent = document.getElementById('map-adherent');

    if (mapadherent) {
        var map = new google.maps.Map(mapadherent, {
            zoom: 10,
            scrollwheel: false,
            center: myLatLng,
//            styles: styles
        });
        setMarkers(map);
    }
}

function setMarkers(map) {
    CustomMarker.prototype = new google.maps.OverlayView();

    CustomMarker.prototype.draw = function() {

        var self = this;

        var div = this.div;

        if (!div) {

            div = this.div = document.createElement('div');

            div.className = 'adherent-marker';

            div.style.position = 'absolute';
            // div.style.cursor = 'pointer';
            // div.style.width = '20px';
            // div.style.height = '40px';
            // div.style.background = 'blue';

            if (typeof(self.args.marker_id) !== 'undefined') {
                div.dataset.marker_id = self.args.marker_id;
            }
            if (typeof(self.args.categorie) !== 'undefined') {
                div.dataset.categorie = self.args.categorie;
            }

            google.maps.event.addDomListener(div, "click", function(event) {
                //alert('You clicked on a custom marker!');
                google.maps.event.trigger(self, "click");
            });

            var panes = this.getPanes();
            panes.overlayImage.appendChild(div);
        }

        var point = this.getProjection().fromLatLngToDivPixel(this.latlng);

        if (point) {
            div.style.left = (point.x - 18) + 'px';
            div.style.top = (point.y - 75) + 'px';
        }
    };

    CustomMarker.prototype.remove = function() {
        if (this.div) {
            this.div.parentNode.removeChild(this.div);
            this.div = null;
        }
    };

    CustomMarker.prototype.getPosition = function() {
        return this.latlng;
    };

    var markers = [];
    // var zoneMarkersCluster = [];

    if (typeof window.coordonnees_map !== 'undefined' && window.coordonnees_map.length > 0) {
        for (var i in window.coordonnees_map) {
            if (window.coordonnees_map.hasOwnProperty(i)) {
                markers.push(window.coordonnees_map[i]);
            }
        }
    } else {
        for (var i in php_vars) {
            if (php_vars.hasOwnProperty(i)) {
                markers.push(php_vars[i]);
            }
        }
    }

    var zoneMarkers = new google.maps.LatLngBounds();

    for (var i = 0; i < markers.length; i++) {

        var id = markers[i].id;
        var lat = markers[i].lat;
        var long = markers[i].long;
        var title = markers[i].titre;
        var categorie = markers[i].categorie;
        var myLatlng = new google.maps.LatLng(lat, long);

        //     var adresse = markers[i][3];
        //     var icon = markers[i][4];
        //     var image = markers[i][5];
        //     var url = markers[i][6];
        //     var optionsMarkers;
        optionsMarkers = {
            position: myLatlng,
            map: map,
            // animation: google.maps.Animation.DROP,
            //         icon: icon,
            title: title
        };

        // var marker = new google.maps.Marker(optionsMarkers);
        var overlay = new CustomMarker(
            myLatlng,
            map,
            {
                marker_id: id,
                categorie: categorie,
                id: i
            }
        );

        // zoneMarkersCluster.push(marker);

        var infowindow = new google.maps.InfoWindow();

        google.maps.event.addListener(overlay, "click", function () {
            console.log("markers",markers);
            console.log("this",this);
            var textecontent =
                '<div class="marker-content">' +
                '<h5>'+markers[this.args.id].titre+'</h5>' +
                '<span>' + markers[this.args.id].ville + '</span><br/>';
            if (markers[this.args.id].site && markers[this.args.id].site.length > 0) {
                textecontent += '<a href="'+ markers[this.args.id].site +'">' + markers[this.args.id].textelien + '</a>';
            }
            textecontent += '</div>';
            infowindow.setContent(textecontent);
//            console.log("Markers click : ",markers[this.id]);
//            console.log("This click : ",this.id);

            infowindow.open(map, this);
        });

        //zoneMarkers.extend(marker.getPosition());
        zoneMarkers.extend(overlay.getPosition());

    }

    // var styles = [{
    //     url: '/wp-content/themes/mrgoodfish/img/pin.png',
    //     height: 48,
    //     width: 30,
    //     anchor: [-18, 0],
    //     textColor: '#ffffff',
    //     textSize: 10,
    //     iconAnchor: [15, 48]
    // }];
    //
    // var options =  {
    //     maxZoom: 14,
    //     gridSize: 20,
    //     styles: styles,
    //     imagePath: '/wp-content/themes/mrgoodfish/img/m'
    // }
    // var markerCluster = new MarkerClusterer(map, zoneMarkersCluster, options);

//    console.log("markers",markers);
    if(markers.length > 1) {
        map.fitBounds(zoneMarkers);
    } else {
        var coordCenter = {lat: parseFloat(markers[0].lat), lng: parseFloat(markers[0].long)};
        map.setCenter(coordCenter);
    }
}
